// servizi/filtri.ts — il catalogo commerciale dei filtri dal server (attivi, piano, prezzo, parametri),
// incrociato con i filtri presenti nel codice dell'app.
import { richiesta } from "./api.ts";
import { eNumero, leggiImpostazione } from "./impostazioni.ts";
import { IMP_APP } from "../costanti.ts";
import { presenteNelCodice } from "../filtri/registro.ts";
import type { PianoFiltro } from "../filtri/tipi.ts";
import type { ProfiloFiltri } from "../filtri/accesso.ts";

export interface FiltroDisponibile {
  id: string;
  numero: number;
  piano: PianoFiltro;
  prezzoCrediti: number;
  parametri: Record<string, number | boolean | string>;
  /** Esclusivo che si ottiene solo con i crediti, anche con Gold (lo dice il server). */
  soloCrediti?: boolean;
}

let cache: { quando: number; filtri: Promise<FiltroDisponibile[]> } | null = null;

export function filtriDisponibili(): Promise<FiltroDisponibile[]> {
  // Il catalogo si rilegge dopo app.filtri_catalogo_cache_secondi (il server lo tiene in cache 60 s).
  const validitaMs = leggiImpostazione(IMP_APP.filtriCatalogoCacheSecondi, 300, eNumero) * 1000;
  if (!cache || Date.now() - cache.quando > validitaMs) {
    const filtri = richiesta<{ filtri: FiltroDisponibile[] }>("/api/v1/filtri").then((r) => r.filtri.filter((f) => presenteNelCodice(f.id)));
    cache = { quando: Date.now(), filtri };
    filtri.catch(() => (cache = null)); // si riproverà alla prossima richiesta
  }
  return cache.filtri;
}

/**
 * Piano e filtri comprati di chi usa l'app (ospite = "base", nulla posseduto). Lo aggiorna servizi/account.ts;
 * chi usa i filtri (la partita) ascolta i cambi per rifare l'elenco dei filtri usabili.
 */
let profilo: ProfiloFiltri = { piano: "base", posseduti: new Set() };
const ascoltatoriProfilo = new Set<() => void>();
export const profiloFiltri = (): ProfiloFiltri => profilo;
export function impostaProfiloFiltri(p: ProfiloFiltri): void {
  const cambiato = p.piano !== profilo.piano || p.tester !== profilo.tester || p.posseduti.size !== profilo.posseduti.size || [...p.posseduti].some((x) => !profilo.posseduti.has(x));
  profilo = p;
  if (cambiato) ascoltatoriProfilo.forEach((f) => f());
}
export function suCambioProfiloFiltri(f: () => void): () => void {
  ascoltatoriProfilo.add(f);
  return () => ascoltatoriProfilo.delete(f);
}
